var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0976562 0.25H16.0977V1.96094L10.0977 7.96094V14.25H6.09766V7.96094L0.0976562 1.96094V0.25ZM15.0977 1.53906V1.25H1.09766V1.53906L7.09766 7.53906V13.25H9.09766V7.53906L15.0977 1.53906ZM15.3867 9.25L16.0977 9.96094L14.3008 11.75L16.0977 13.5391L15.3867 14.25L13.5977 12.4531L11.8086 14.25L11.0977 13.5391L12.8945 11.75L11.0977 9.96094L11.8086 9.25L13.5977 11.0469L15.3867 9.25Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear-filter.b958f023c22bbe7fce60d2739e936b8f.svg";
export { ForwardRef as ReactComponent };